import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { IsNull, localStoreObjects } from "../utilities/util";
import { useAuth } from "./features/AuthContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const [_logout, setLogout] = useState(false);
  const { isAuthenticated, login, logout } = useAuth();

  const [selectedHost, setSelectedHost] = useState(() => {
    return localStorage.getItem("apiHost") || "http://localhost:5000/";
  });

  // const apiHosts = [
  //   { label: "Production", value: "https://prod.smartmaheshwari.com/api/" },
  //   { label: "Staging", value: "https://api.smartmaheshwari.com/" },
  //   { label: "Localhost", value: "http://localhost:5000/" }
  // ];

  const handleHostChange = (value) => {
    setSelectedHost(value);
    localStorage.setItem("apiHost", value);
  };

  useEffect(() => {
    const _logged = localStorage.getItem(localStoreObjects.userId);
    setLogout(IsNull(_logged));

    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // const navLinks = [
  //   { to: "/", label: "Home" },
  //   { to: "/Privacy", label: "Privacy" },
  //   {
  //     to: "#",
  //     label: "Requests",
  //     submenu: [
  //       { to: "/TardinessData", label: "Tardiness Notices" },
  //       { to: "/ScheduledRequests", label: "Scheduled Request" },
  //     ],
  //   },
  // ];

  // if (!isAuthenticated) {
  //   navLinks.push({ to: "/login", label: "Login" });
  // } else {
  //   navLinks.push({
  //     to: "#",
  //     label: "Logout",
  //     onClick: () => {
  //       localStorage.removeItem(localStoreObjects.userId);
  //       localStorage.removeItem(localStoreObjects.bgmiProfile);
  //       localStorage.removeItem(localStoreObjects.profilePic);
  //       localStorage.removeItem(localStoreObjects.step);
  //       logout();
  //     },
  //   });
  // }

  return (
    <nav className="bg-transparent shadow-sm border-b z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 py-3">
        {/* Empty div for balancing if needed, or logo/title */}
        <div className="w-24 md:flex hidden"></div> 

        <Link to="/" className="block">
          <h2 className="text-red-500 font-bold text-2xl underline">DAILY SALES REPORT</h2>
        </Link>

        <div className="flex items-center space-x-4">
          {isAuthenticated && (
            <button
              onClick={() => logout()}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors shadow-sm"
            >
              Logout
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
